import Vue from "vue/dist/vue.esm";

var fukushouOddsTable = Vue.extend({
  template: `
    <table class="table table-vote-number">
      <tr class="text-center">
        <th></th>
        <th v-for="(item, key) in voteInfo.entries" :class="'bg-lighten-' + key">{{ key }}</th>
      </tr>
      <tr class="text-center">
        <th>名前</th>
        <th v-for="(item, key) in voteInfo.entries">{{item.name}}</th>
      </tr>
      <tr class="text-center">
        <th>LG</th>
        <th v-for="(item, key) in voteInfo.entries" class="bg-gray-dark">{{ item.locker_ground }}</th>
      </tr>
      <tr class="text-center">
        <th>複勝オッズ</th>
        <td v-for="(row, syaban1, index) in voteInfo.entries">
          <a class="block" v-if="voteInfo.oddsTableData[syaban1]" @click.prevent="addOddsTableItems(voteInfo.oddsTableData[syaban1], syaban1)" :class="{'is-absent': !voteInfo.oddsTableData[syaban1].is_valid}">
            {{ voteInfo.oddsTableData[syaban1].normalize_rate }}
          </a>
        </td>
      </tr>
    </table>
  `
});

export default {
  fukushouOddsTable
}
